export const PpzAuthorizationListType = {
  All: 1,
  NotAuthorized: 2,
  Authorized: 3,
  AuthorizedExpiringIn6Months: 5,
  AuthorizedExpired: 4
} as const

export type PpzAuthorizationListType = typeof PpzAuthorizationListType[keyof typeof PpzAuthorizationListType]

export const PpzAuthorizationListTypes: [PpzAuthorizationListType, string][] = [
  [PpzAuthorizationListType.All, 'Všechny záznamy'],
  [PpzAuthorizationListType.NotAuthorized, 'Pouze neautorizované'],
  [PpzAuthorizationListType.Authorized, 'Pouze autorizované'],
  [PpzAuthorizationListType.AuthorizedExpiringIn6Months, 'Autorizované s platností kratší než 6 měsíců'],
  [PpzAuthorizationListType.AuthorizedExpired, 'Autorizované s ukončenou platností'],
]

export const getPpzAuthorizationListTypeName = (type: PpzAuthorizationListType | undefined) => {
  return type !== undefined ? PpzAuthorizationListTypes.find(([key]) => key === type)?.[1] : undefined
}